export function island<T>(
	item:T,
	iterateConnections:(item:T)=>Iterable<T>,
){
	const open=new Set<T>();

	const island=new Set<T>();
	island.add(item);
	let working=new Set<T>();
	working.add(item);

	while(working.size>0){
		const next=new Set<T>();
		for(const a of working){
			for(const b of iterateConnections(a)){
				if(open.has(b)){
					open.delete(b);
					island.add(b);
					next.add(b);
				}
			}
		}
		working=next;
	}
	return island;
}
